export const TOGGLE_UPLOAD_IMAGE_MODAL= 'TOGGLE_UPLOAD_IMAGE_MODAL';
export const TOGGLE_DOWNLOAD_IMAGE_MODAL= 'TOGGLE_DOWNLOAD_IMAGE_MODAL';